import app from 'flarum/common/app';
// The date a MM-DD birthday next falls on, today included. Feb 29 falls on Feb 28 in other years.
export function nextBirthday(monthDay, today = dayjs()) {
  const start = today.startOf('day');
  const inYear = year => {
    const date = dayjs(`${year}-${monthDay}`);
    return date.format('MM-DD') === monthDay ? date : dayjs(`${year}-02-28`);
  };
  const thisYear = inYear(start.year());
  return thisYear.isBefore(start) ? inYear(start.year() + 1) : thisYear;
}
export function isBirthdayToday(user, today = dayjs()) {
  const monthDay = user.birthMonthDay();
  return !!monthDay && nextBirthday(monthDay, today).isSame(today, 'day');
}
export function formatBirthday(monthDay) {
  // 2000 is a leap year, so Feb 29 formats as itself.
  return app.translator.formatDateTime(dayjs(`2000-${monthDay}`), 'datlechin-birthdays.lib.datetime_formats.birthday');
}
export function latestBirthday() {
  return dayjs().subtract(app.forum.attribute('datlechin-birthdays.minAge') || 0, 'year').format('YYYY-MM-DD');
}
flarum.reg.add('datlechin-birthdays', 'common/utils/birthday', { nextBirthday: nextBirthday,isBirthdayToday: isBirthdayToday,formatBirthday: formatBirthday,latestBirthday: latestBirthday, });